import { useContext, useState } from "react";
import { api } from "../../../api";
import { SettingsSidebar } from "../../../externalComponents/SettingsSidebar";
import { PageHeading } from "../../../externalComponents/PageHeading";
import { OverflowFrame } from "../../../externalComponents";
import { CustomerContext } from "../../../providers";
import {
  SwitchField,
  SwitchOnOff,
} from "../../../externalComponents/tailwind/switch";
import { Text } from "../../../externalComponents/tailwind/text";
import { Input } from "../../../externalComponents/tailwind/input";
import {
  Description,
  ErrorMessage,
  Field,
  Label,
} from "../../../externalComponents/tailwind/fieldset";
import { Badge } from "../../../externalComponents/tailwind/badge";
import {
  InformationCircleIcon,
  LightBulbIcon,
} from "@heroicons/react/16/solid";

export default function DataExportsPage() {
  const { customer } = useContext(CustomerContext);

  const [isExportDataChecked, setIsExportDataChecked] = useState(
    customer.isExportCampaignsDataGoogleSheetActivated,
  );
  const [isEditing, setIsEditing] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isUrlMissing, setIsUrlMissing] = useState(false);
  const [spreadsheetUrl, setSpreadsheetUrl] = useState(
    customer.campaignsDataSpreadsheetUrl || "",
  );

  const saveGeneralSettings = async () => {
    if (spreadsheetUrl === "") {
      setIsUrlMissing(true);
    } else {
      setIsUrlMissing(false);
      setIsLoading(true);
      await api.customer.update(customer.id, {
        isExportCampaignsDataGoogleSheetActivated: isExportDataChecked,
        campaignsDataSpreadsheetUrl: spreadsheetUrl,
      });
      setIsLoading(false);
      setIsEditing(false);
    }
  };

  return (
    <>
      <SettingsSidebar>
        <PageHeading
          title="Exports"
          primaryAction="Save"
          handlePrimaryAction={saveGeneralSettings}
          isPrimaryLoading={isLoading}
        />
        <OverflowFrame>
          <div className="mt-5 max-w-4xl">
            <Badge color="amber">
              <InformationCircleIcon className="w-5 h-5" />
              <Text>Invite</Text>
              <Text className="font-bold">
                gadget@simio-434617.iam.gserviceaccount.com
              </Text>
              <Text>with editing rights to the spreadsheet</Text>
            </Badge>
            <Field>
              <div className=" mt-5">
                <div className="min-w-[22rem] flex content-center items-center">
                  <SwitchField className="">
                    <Label className="font-bold">
                      Export daily performances
                    </Label>
                    <SwitchOnOff
                      name="activate_export_daily_performances"
                      checked={isExportDataChecked}
                      onChange={(checked) => {
                        setIsExportDataChecked(checked);
                        setIsEditing(true);
                      }}
                    ></SwitchOnOff>
                  </SwitchField>
                  {isEditing && (
                    <Text className="text-pink text-xs ml-3">
                      Unsaved settings changes
                    </Text>
                  )}
                </div>
                <Description className="flex items-center">
                  <LightBulbIcon className="h-4 w-4 mr-2" />{" "}
                  <Text className="text-sm">
                    Data exports are performed daily at 3am (Europe/Paris)
                  </Text>
                </Description>
              </div>

              {isExportDataChecked && (
                <div className="mt-4">
                  <Label>Google Spreadsheet URL</Label>
                  <Input
                    name="Spreadsheet url field"
                    value={spreadsheetUrl}
                    onChange={(e) => {
                      setIsEditing(true);
                      setSpreadsheetUrl(e.target.value);
                    }}
                    invalid={isUrlMissing}
                  />
                </div>
              )}
              {isUrlMissing && (
                <Field>
                  <ErrorMessage>Url is required</ErrorMessage>
                </Field>
              )}
            </Field>
          </div>
        </OverflowFrame>
      </SettingsSidebar>
    </>
  );
}
